import axios from "axios";
import { getBackendUrl } from "@/lib/backend";
import { getRuntimeEnv } from "@/lib/runtimeConfig";

export const DEFAULT_AUTO_LOGIN_EMAIL =
  getRuntimeEnv("REACT_APP_AUTO_LOGIN_EMAIL", "admin@mahaedume.gov.in");
export const DEFAULT_AUTO_LOGIN_PASSWORD =
  getRuntimeEnv("REACT_APP_AUTO_LOGIN_PASSWORD", "admin123");

/** Enabled by default for local hosting; set REACT_APP_AUTO_LOGIN=false to disable. */
export function isAutoLoginEnabled() {
  const flag = getRuntimeEnv("REACT_APP_AUTO_LOGIN", "true").toLowerCase();
  return flag !== "false" && flag !== "0" && flag !== "no";
}

export function clearStoredSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  delete axios.defaults.headers.common["Authorization"];
}

export function restoreSessionFromStorage() {
  const token = localStorage.getItem("token");
  const savedUser = localStorage.getItem("user");
  if (!token || !savedUser) return null;

  try {
    const user = JSON.parse(savedUser);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return user;
  } catch {
    clearStoredSession();
    return null;
  }
}

async function validateStoredToken() {
  await axios.get(`${getBackendUrl()}/api/auth/me`);
}

export async function loginWithCredentials(email, password) {
  const response = await axios.post(`${getBackendUrl()}/api/auth/login`, {
    email,
    password,
  });
  const { access_token, user } = response.data;
  localStorage.setItem("token", access_token);
  localStorage.setItem("user", JSON.stringify(user));
  axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
  return user;
}

export async function performAutoLogin() {
  if (!isAutoLoginEnabled()) return null;
  const existing = restoreSessionFromStorage();
  if (existing) return existing;
  return loginWithCredentials(DEFAULT_AUTO_LOGIN_EMAIL, DEFAULT_AUTO_LOGIN_PASSWORD);
}

/** Restore session, or auto-login when enabled. Used before entering dashboards. */
export async function ensureAuthenticated() {
  const existing = restoreSessionFromStorage();
  if (existing) {
    try {
      await validateStoredToken();
      return existing;
    } catch (error) {
      if (error?.response?.status !== 401) throw error;
      clearStoredSession();
    }
  }
  return performAutoLogin();
}
